export default "__VITE_ASSET__BUNUpSRj__"